import cx from 'classnames';

import Text from 'shared_components/Text';
import useInViewport from 'hooks/useInViewport';

import kolectivGG from 'assets/cards/kolectivGG.png';
import cardBack from 'assets/cards/cardBack.png';

import styles from '../../styles.module.scss';

const TheCards = (props: React.HTMLProps<HTMLDivElement>) => {
  const { getInView, inView } = useInViewport();

  return (
    <div {...props} className={cx(styles.theCards, props.className)}>
      <div
        className={cx(styles.theCard, {
          [styles.inView]: window.innerWidth > 1600 || inView,
        })}
        ref={getInView}
      >
        <div className={styles.theCardsItem}>
          <img
            src={kolectivGG}
            alt="Kolectiv.GG"
            className={styles.cardImage}
          />
        </div>
        <img
          src={cardBack}
          alt="Kolectiv Card Back"
          className={styles.theCardsBack}
        />
      </div>
      <div className={styles.cardsText}>
        <Text
          as="h3"
          size="3xl"
          weight="medium"
          uppercase
          className={styles.gradientText}
        >
          The <strong>Cards</strong>
        </Text>
        <div className={styles.textBlocks}>
          <div>
            <Text as="h6" type="white" weight="bold" size="lg" capitalize>
              Tokenized NFT&apos;s
            </Text>
            <Text as="p" size="sm">
              Brought to you by the Ethereum blockchain and ERC-721, these are
              verifiably one of a kind items.
            </Text>
          </div>
          <div>
            <Text as="h6" type="white" weight="bold" size="lg" capitalize>
              Unique Mint Numbers
            </Text>
            <Text as="p" size="sm">
              Every card is unique and bears its own mint number showing the
              order in which it was created. Low mints receive more leaderboard
              points so are highly sought by collectors.
            </Text>
          </div>
          <div>
            <Text as="h6" type="white" weight="bold" size="lg" capitalize>
              Multiple sets to collect
            </Text>
            <Text as="p" size="sm">
              A wide ranging cross section of the people, projects and artists
              across multiple different drops of varying themes.
            </Text>
          </div>
          {/* <div>
            <Text as="h6" type="white" weight="bold" size="lg" capitalize>
              Unique digital signatures
            </Text>
            <Text as="p" size="sm">
              Get lucky and unpack a one-of-a-kind card digitally signed by the
              artist
            </Text>
          </div> */}
          <div>
            <Text as="h6" type="white" weight="bold" size="lg" capitalize>
              Ultra Rare Mythic and Exotic Insert Cards
            </Text>
            <Text as="p" size="sm">
              Attain ultra rare cards by topping the leaderboards, racing to
              finish the set first or with luck by getting an ultra rare pack
              insert. We’ll have more to share about these special cards in the
              lead up to the presale.
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TheCards;
